module.exports = __webpack_public_path__ + "static/media/IMG_1287.0991883b.JPG";